import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { getMembershipStateList } from './accountsModule';
import useAccountActions from './useAccountActions';

export default function useMembershipStateList() {
  const actions = useAccountActions();
  const membershipStateList = useSelector(getMembershipStateList);

  useEffect(() => {
    if (!membershipStateList.networkStatus.isUpToDate) {
      actions.loadMembershipStateList();
    }
  }, [actions, membershipStateList.networkStatus.isUpToDate]);

  return membershipStateList;
}
